export default {
    "/": {
        "title": "Taoify - Жаһандық сату үшін басқару платформасы | Кітайдан тауарлар, жаһандық сату",
        "desc": "Taoify бір портталықта сайтын құру, аудару, тауарларды орналастыру, логистика, төлеу, маркетинг: 18 AI жұмысшыңыз іске асуына көмектеседі, 20 тілде дүкен ашу, Кітай тауарларын жаһандық сатуға."
    },
    "/feature": {
        "title": "Функциялар · Дүкен ашу үшін қажетті нәрселер, бұл бетте барлығы бар · Taoify",
        "desc": "Сайт құру, аудару, тауарларды орналастыру, жіберу, төлеу, клиенттерді тарту – Taoify бір портталықта кросс-бордер сату үшін 15 модульді жинақтады, сізге сыртқы 7-8 инструменттерді пайдалану қажет емес."
    },
    "/ai-staff": {
        "title": "AI жұмысшылар · 18 AI жұмысшы, ең шешімділері трафикті алуға арналған · Taoify",
        "desc": "18 AI жұмысшының ішінде, өсу тобының 5-і «келмейтін адамдар» мәселесін шешеді: 12 нұсқаулық тексеру, 30 күндік маркетинг планы, бір тауарды 9 каналға қолдануға ыңғайлау, автоматты маркетинг хаттары алдындағы сатып алушыларды қайта тарту."
    },
    "/logistics": {
        "title": "Кросс-бордер логистика · Сіздің рукаңыздан клиентке · Taoify",
        "desc": "Бастапқы этап, таможня, негізгі жол, соңғы жеткізу, үш жолды тауар мен уақытқа қарай таңдаңыз. YunTu, Yanwen, 4PX байланысты, этикеткалар, трекинг, қателерді бір портталықта басқаруға болады."
    },
    "/payment": {
        "title": "Төлеу және есептеу · Клиенттерге ыңғайлы төлеу · Taoify",
        "desc": "PayPal, Stripe, кредит карталары, Alipay тіркелгенше пайдалануға болады. Төмен тауып, юаньмен шығару, T+7 есептеу, комиссиялық ставкалар және кіруге уақыты ашық беріледі."
    },
    "/pricing": {
        "title": "Бағалар · Пайдалану пакеттері + деңгейлі комиссия · Taoify",
        "desc": "Дүкендер пайдалану пакеттеріне қарай төленеді: базалық $15/ауыс, стандартты $29/ауыс, флагман $59/ауыс, үш айлық немесе жылдық төлеу экономияға ыңғайлау. Комиссия сауда айлық суммасына қарай деңгейлі, ең төмен 3%."
    },
    "/cases": {
        "title": "Сатушылардың кейіпкерлері · Олар да бірдей істі жасап жатыр · Taoify",
        "desc": "Үйгурдегі қоймалар, Шэньчжэндегі 3C, Гуандундегі киім-кеңсек, сондай-ақ Германияда, Америкада, Франциядағы сатушылар - алты адам, алты бастау нүктесі, бір әдіс."
    },
    "/sign-up": {
        "title": "Дүкен ашу - Taoify тегін тіркелу",
        "desc": "10 минутта брендтік өзіндік веб-сайт жасаңыз, кодды білу міндетті емес, пайдалану үшін толық функционал. Taoify-ге тіркеліп, электрондық коммерция саяхатыңызды бастаңыз."
    },
    "/for-china-sellers": {
        "title": "Қытай сатушыларына · Сіз ғана товарды таңдап бағасын қоясыз, келесін біз жасаймыз · Taoify",
        "desc": "Веб-сайт құру, аударма, жүктеу ақысы, этикеткаларды басып шығару, сұрақтарға жауап беру - платформа сіз үшін барлығын жасайды. Пайдалану үшін абоненттік тариф + қадамдық комиссия (бірде 3%)."
    },
    "/for-global-sellers": {
        "title": "Сыртқы сатушыларға: Қытайдағы қоймалардан таңдаңыз, өзіңіздің дүкеніңіздегі сатыңыз · Taoify",
        "desc": "Товарды сақтау, стокқа салу: Қытай құбылысынан таңдап, қоймадан тутындырып, сіз баға айырмашылығын табасыз. BuyLink 1688, Таобао сілтемелерін сіздің товарыңызға айналдырады."
    },
    "/template-index": {
        "title": "Шаблондар базары - Taoify профессионалдық веб-сайт темалары",
        "desc": "Барлық проекттерге қолайлы профессионалдық веб-сайт темалары, өнеркәсіптік шаблондар тегін қолданылатын, өзіңізге қажет болған брендинг мен функцияларды өзгертуға болады."
    },
    "/question": {
        "title": "Көмек центрі · Сұрақтарды бірінші осында іздеңіз · Taoify",
        "desc": "Дүкен ашу, қызметтер, товарларды қойу, тапсырыс логистикасы, ақша алу, маркетинг, аккаунт рұқсаттары - сұрақтар топтар бойынша сұрыпталған, егер таба алмасаңыз, тапсырыс беріңіз."
    },
    "/about-us": {
        "title": "Taoify туралы · Біз не істеп жатырмыз",
        "desc": "Taoify - бұл сійіп өту үшін дерекқордық сатушылар үшін біріктірілген платформа: сайтын құру, аудару, қойып шығару, логистика, ақша алу, маркетинг бір панельде орындалады."
    },
    "/privacy-policy": {
        "title": "Приваттық ережесі · Taoify",
        "desc": "Taoify сіздің жеке ақпаратыңызды қалай жинауы, қолдануы, сақтауы және қорғауы туралы, содан ерте сіз өз деректеріңізге қандай ұқымдардына ие боласыз."
    },
    "/terms-service": {
        "title": "Қызмет шарттары · Taoify",
        "desc": "Taoify платформасының қызметтерін пайдаланудың шарттары мен мүшеліктері: ақаунт, дүкен, тапсырыс, есептеу және аты-анымен жоғарылау."
    },
    "/consumer-agreement": {
        "title": "Ақысыз алып қайтару саясаты · Taoify",
        "desc": "Taoify платформасындағы тапсырыстар үшін ақысыз алып қайтару және кейінгі қызмет ережелері: өтінім беру шарттары, өңдеу уақыты мен ақша тиімді түрде келетін тәсілдері."
    },
    "/user-agreement": {
        "title": "Пайдаланушы келісімі · Taoify",
        "desc": "Taoify жазылу және қолдану алдында: тіркелу, дүкен ұстайту ережелері мен платформа қызметтерін сипаттау туралы оқыңыз."
    }
}
